export default "__VITE_ASSET__4249dd58__"